import React from "react";
import ProductMock from "./ProductMock";

// Hero dashboard visual — used on the homepage as a clean stage-setter (no headline copy)
const heroVisualConfig = {
  chromeCenter: "flows / onboarding · v3",
  sidebar: {
    title: "Approach",
    items: [
      { label: "User-centered thinking", active: false, done: true },
      { label: "System-driven design", active: true, done: false },
      { label: "Behavior-focused flows", active: false, done: false },
    ],
    suggestion: {
      label: "AI Suggestion",
      body: "Simplify complex systems into clear, actionable experiences.",
    },
  },
  main: {
    stepLabel: "Personalisation step",
    stepTitle: "Turning complexity into clear, usable experiences",
    metrics: [
      { t: "Projects", v: "10+", d: "end-to-end product experiences" },
      { t: "Domains", v: "4+", d: "health-tech, fintech, AI, consumer" },
      { t: "Experience", v: "4+ yrs", d: "product & UX design" },
    ],
    flowTitle: "Design Flow",
    flow: ["Understand", "Structure", "Simplify", "Design", "Iterate"],
    flowActive: 2,
  },
  leftCard: {
    label: "Component",
    title: "Decision card · v2",
    body: "A modular component designed to simplify decision-making by surfacing the right choices at the right time. Built for flexibility across flows and user states.",
  },
  rightCard: {
    label: "Design philosophy",
    body: "Reduce friction. Guide decisions.",
  },
};

const HeroBackdrop = () => (
  <div className="pointer-events-none absolute inset-0 -z-10">
    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1100px] h-[600px] bg-gradient-to-b from-neutral-100 dark:from-neutral-900 to-transparent rounded-full blur-3xl opacity-60" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(0,0,0,0.05)_1px,transparent_0)] dark:bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.06)_1px,transparent_0)] [background-size:32px_32px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_30%,transparent_75%)]" />
  </div>
);

const AvailabilityPill = () => (
  <div className="flex justify-center mb-10">
    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-neutral-200 dark:border-neutral-800 bg-white/70 dark:bg-neutral-900/60 backdrop-blur-sm text-[12.5px] text-neutral-700 dark:text-neutral-300">
      <span className="relative flex h-1.5 w-1.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-60" />
        <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-500" />
      </span>
      Product Designer · 2026
    </div>
  </div>
);

const HeroVisual = () => (
  <section id="top" className="relative pt-28 lg:pt-32 pb-12 lg:pb-16 overflow-hidden">
    <HeroBackdrop />
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
      <AvailabilityPill />
      <ProductMock {...heroVisualConfig} leftCardWidth="w-[240px]" rightCardWidth="w-[220px]" />
    </div>
  </section>
);

export default HeroVisual;
